<template lang="pug">
  div.body.body-table.container-table
    div.table-choose-panel
      div.toolbar-table
        e-select-list(
        :options="selectListOptions"
        v-model="operationType"
        )

        div.toolbar.toolbar--modal
          div.line
            form(@submit.prevent="letSearch")
              // input(type="search" placeholder="" v-model="searchModel")
            div.parameters
            div.actions-panel
              e-button-add(@click="addNewRowToTable")
              // button(v-if="role!=='guest'" type="button" @click="addNewRowToGarbageTable").actions-panel__button.btn-add.green

      div(v-if="operationType === 'tko'")
        e-table-editable(
        ref="tko"
        :attributes="tkoAttr"
        :dataUrl="tkoDataUrl"
        :postUrl="postUrl"
        :patchUrl="patchUrl"
        :deleteUrl="deleteUrl"
        :enableOnAdd="enableOnAdd"
        :tableInOnlineMode="tableInOnlineMode"
        :afterFetchData="afterFetchData"
        :summaryColumns="tkoSummaryColumns"
        )

      div(v-if="operationType === 'separate_collection'")
        e-table-editable(
        v-if="fields.is_separate"
        ref="separateCollection"
        :attributes="separateCollectionAttr"
        :dataUrl="separateCollectionDataUrl"
        :postUrl="postUrl"
        :patchUrl="patchUrl"
        :deleteUrl="deleteUrl"
        :enableOnAdd="enableOnAdd"
        :tableInOnlineMode="tableInOnlineMode"
        :afterFetchData="afterFetchData"
        :summaryColumns="separateCollectionColumns"
        )
        div(v-else) Данная таблица отображается только у объектов с признаком раздельного сбора
</template>

<script>
  import {msn, core} from '../../../../api/api-endpoints.js'
  import {msnOffline} from '../../../../api/api-offline-endpoints.js'

  const DEFAULT_VALIDATION_DOUBLE_PATTERN = '^(\\d*((\\.\\d{0,2}))?(\\d))$'
  const DEFAULT_INVALID_DOUBLE_MSG = 'Допустимы только число вида 0.000'

  export default {
    name: 'container-table',
    props: {
      id: null,
      tabView: null,
      fields: {
        type: Object,
        default: function () {
          return {}
        }
      }
    },
    data () {
      return {
        operationType: null,
        search: null
      }
    },
    computed: {
      selectListOptions () {
        let defList = [
          {
            id: 'tko',
            name: 'Контейнеры для ТКО'
          }
        ]
        if (this.fields.is_separate) {
          defList.push({
            id: 'separate_collection',
            name: 'Организация раздельного сбора'
          })
        }
        return defList
      },
      tableInOnlineMode () {
        return this.$route.params.id
      },
      enableOnAdd () {
        return []
      },
      tkoSummaryColumns () {
        return ['volume', 'capacity', 'count']
      },
      tkoAttr () {
        return {
          msnContainerTypeName: {
            label: 'Вид контейнера',
            validationRulePattern: '(\\.*)',
            placeholder: 'Начните вводить название',
            required: false,
            suggestion: {
              useInnerSearch: true,
              options: this.collectionMsnContainerType,
              onSelect: this.onSelectContainerType
            }
          },
          volume: {
            label: 'Объем, куб.м',
            validationRulePattern: DEFAULT_VALIDATION_DOUBLE_PATTERN,
            required: true,
            calcSum: this.calcVolumeSum,
            invalidMessage: DEFAULT_INVALID_DOUBLE_MSG
          },
          capacity: {
            label: 'Вместимость, тонн',
            validationRulePattern: DEFAULT_VALIDATION_DOUBLE_PATTERN,
            required: true,
            calcSum: this.calcCapacitySum,
            invalidMessage: DEFAULT_INVALID_DOUBLE_MSG
          },
          count: {
            label: 'Количество на площадке, шт',
            required: true,
            placeholder: '',
            validationRulePattern: '^([0-9]+)$',
            invalidMessage: 'Допустимы только целые числа',
            calcSum: this.calcToInt
          }
        }
      },
      separateCollectionColumns () {
        return ['volume', 'capacity', 'count']
      },
      separateCollectionAttr () {
        return {
          msnContainerTypeName: {
            label: 'Вид контейнера',
            validationRulePattern: '(\\.*)',
            placeholder: 'Начните вводить название',
            required: false,
            suggestion: {
              useInnerSearch: true,
              options: this.collectionMsnContainerType,
              onSelect: this.onSelectContainerType
            }
          },
          msn_container_garbage_type_id: {
            label: 'Группа отходов',
            required: true,
            select: {
              options: this.collectionMsnContainerGarbageType
            },
            transform: (model) => {
              try {
                return this.collectionMsnContainerGarbageType.find(v => v.id === model.msn_container_garbage_type_id).name
              } catch (e) {
                return ' - '
              }
            }
          },
          msn_collecting_type_id: {
            label: 'Способ организации сбора',
            required: true,
            select: {
              options: this.collectionMsnCollectionType
            },
            transform: (model) => {
              try {
                return this.collectionMsnCollectionType.find(v => v.id === model.msn_collecting_type_id).name
              } catch (e) {
                return ' - '
              }
            }
          },
          volume: {
            required: true,
            label: 'Объем, куб.м',
            validationRulePattern: DEFAULT_VALIDATION_DOUBLE_PATTERN,
            calcSum: this.calcVolumeSum,
            invalidMessage: DEFAULT_INVALID_DOUBLE_MSG
          },
          capacity: {
            required: true,
            label: 'Вместимость, тонн',
            validationRulePattern: DEFAULT_VALIDATION_DOUBLE_PATTERN,
            calcSum: this.calcCapacitySum,
            invalidMessage: DEFAULT_INVALID_DOUBLE_MSG
          },
          count: {
            label: 'Количество на площадке, шт',
            required: true,
            validationRulePattern: '^([0-9]+)$',
            invalidMessage: 'Допустимы только целые числа',
            calcSum: this.calcToInt
          }
        }
      },
      tkoDataUrl () {
        if (this.tableInOnlineMode) {
          let routeQuery = {
            query: {
              type: 'tko'
            }
          }
          if (this.search) {
            routeQuery.query.q = this.search
          }

          return msn.containersTable(this.id, routeQuery)
        }
        // if new record, offline save
        return msnOffline.tkoContainersTable(this.$route.name)
      },
      separateCollectionDataUrl () {
        if (this.tableInOnlineMode) {
          let routeQuery = {
            query: {
              type: 'separate_collection'
            }
          }
          if (this.search) {
            routeQuery.query.q = this.search
          }

          return msn.containersTable(this.id, routeQuery)
        }
        // if new record, offline save
        return msnOffline.separateContainersTable(this.$route.name)
      },
      collection () {
        if (this.$store.getters.readUrlEndpoint(this.getCollectionEndpoint())) {
          return this.$store.getters.readUrlEndpoint(this.getCollectionEndpoint())
        }
        return {
          msn_collecting_type: [],
          msn_container_garbage_type: []
        }
      },
      collectionMsnCollectionType () {
        return this.collection.msn_collecting_type
      },
      collectionMsnContainerGarbageType () {
        return this.collection.msn_container_garbage_type
      },
      collectionMsnContainerType () {
        return this.collection.container
      }
    },
    created () {
      this.fetchData()
    },
    methods: {
      calcToInt (ctx, sum) {
        return Math.round(sum || 0)
      },
      calcVolumeSum (ctx) {
        // logic from /src/app/msn/mixins/msn-form.js
        // containersVolumeSum
        let sum = 0
        if (ctx.data && ctx.data.data && ctx.data.data.length > 0) {
          ctx.data.data.forEach(v => {
            if (v.volume && v.count && !isNaN(v.volume * v.count)) {
              sum = sum + (v.volume * v.count)
            }
          })
        }
        return sum.toFixed(3)
      },
      calcCapacitySum (ctx) {
        let sum = 0
        if (ctx.data && ctx.data.data && ctx.data.data.length > 0) {
          ctx.data.data.forEach(v => {
            if (v.volume && v.count && !isNaN(v.volume * v.count)) {
              sum = sum + (v.capacity * v.count)
            }
          })
        }
        return sum.toFixed(3)
      },
      onSelectContainerType (ctx, $event, model) {
        if ($event && $event.id) {
          model.msnContainerTypeName = $event.name
          model.container_id = $event.id
        } else {
          model.msnContainerTypeName = ''
          model.container_id = ''
        }
      },
      fetchData () {
        this.$store.dispatch('updateUrlEndpoint', {
          endpoint: this.getCollectionEndpoint(),
          fromCache: true
        })
      },
      getCollectionEndpoint () {
        return core.collection('container,msn_container_garbage_type,msn_collecting_type')
      },
      afterFetchData (ctx, data) {
        for (let i = 0; i < data.data.length; i++) {
          if (data.data[i].container) {
            data.data[i].msnContainerTypeName = data.data[i].container.name
          }
        }
        return data
      },
      postUrl (context, model) {
        return msn.containersTableCreate(this.id)
      },
      patchUrl (context, model) {
        return msn.containersTableUpdate(model.id)
      },
      deleteUrl (context, model) {
        return msn.containersTableDelete(model.id)
      },
      addNewRowToTable () {
        const Model = () => {
          return {
            type: JSON.parse(JSON.stringify(this.operationType)),
            msn_container_garbage_type_id: '',
            msn_collecting_type_id: '',
            volume: '',
            capacity: '',
            count: ''
          }
        }
        if (this.operationType === 'tko') {
          this.$refs.tko.createRow(new Model())
        } else if (this.operationType === 'separate_collection') {
          this.$refs.separateCollection.createRow(new Model())
        }
      }
    }
  }
</script>
